import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreateAppointmentSlot = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({
      date,
      quantity,
      doctor,
    }: {
      date: Date;
      quantity: number;
      doctor: string;
    }) => {
      return api.post(`appointments/v-slots`, {
        start_time: date.toISOString(),
        quantity,
        ...(doctor && {
          doctor_assigned: doctor,
        }),
      });
    },
    onSuccess: () => {
      showSuccessNotification({ message: "create-appointment-slot-success" });
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.slots() }); // Only need this and not slotsWithFilters because both will need to be invalidated and this takes care of both
    },

    onError: (res: any) => {
      console.error("[From Create Appointment Slot]", res);
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.slots() });

      // todo: Handle 400 error when slot is already taken

      handleErrors(res, "mutation");
    },
  });
};
